import { render } from "./device-details-page.vue?vue&type=template&id=38655910&ts=true"
import script from "./device-details-page.ts?vue&type=script&lang=ts"
export * from "./device-details-page.ts?vue&type=script&lang=ts"

import "./device-details-page.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__